import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import StoreTableRow from './StoreTableRow';
import StoreMobileTable from './StoreMobileTable';
import StoreMobileTableRow from './StoreMobileTableRow';

// show table for windows & mobile view
const StoreTable = ({ children, fields, threshold }) => (
  <Table
    className={`d-${threshold}-down-none`}
    style={{ backgroundColor: 'transparent' }}
  >
    <TableHead>
      <TableRow>
        {fields.map((field, index) => (
          <TableCell
            colSpan={field.colSpan || 1}
            key={index}
          >
            {field.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {children}
    </TableBody>
  </Table>
);

StoreTable.propTypes = {
  children: PropTypes.node,
  fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  threshold: PropTypes.string,
};

StoreTable.defaultProps = {
  children: null,
  threshold: 'md',
};

StoreTable.StoreTableRow = StoreTableRow;
StoreTable.StoreMobileTable = StoreMobileTable;
StoreTable.StoreMobileTableRow = StoreMobileTableRow;

export default StoreTable;
